import { useEffect, useCallback } from 'react';

import { PATHS } from 'src/routes/paths';
import { useBoolean } from 'src/hooks/use-boolean';
import { useNavigate } from 'src/hooks/use-navigate';

import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function AuthGuard({ children }: Props) {
  const { loading } = useAuthContext();

  return <>{loading ? <SplashScreen /> : <Container>{children}</Container>}</>;
}

// ----------------------------------------------------------------------

function Container({ children }: Props) {
  const navigate = useNavigate();

  const { authenticated } = useAuthContext();

  const { value: checked, onTrue: onChecked } = useBoolean();

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.pathname + window.location.search,
      }).toString();

      const href = `${PATHS.auth.login}?${searchParams}`;

      navigate(href, { replace: true });
    } else {
      onChecked();
    }
  }, [authenticated, navigate, onChecked]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
}
